import * as queryString from 'query-string';

declare global {
  interface Window {
    env: { [name: string]: string };
  }
}

function getEnv(envName: string, default1: string | undefined, default2: string): string {
  // see if we have it in the window object
  if (window != null && window.env != null && window.env[envName] != null) return window.env[envName];

  const query = queryString.parse(window.location.search);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (query[envName] != null) return query[envName] as any as string;

  // in environment variables?
  if (default1 != null) return default1;

  // fall back to dotenv specified env vars inside process
  return default2;
}

const env = {
  BASENAME: getEnv('VITE_BASENAME', import.meta.env.VITE_BASENAME, ''),
  STAGE: getEnv('VITE_STAGE', import.meta.env.VITE_STAGE, ''),
  API_URL: getEnv('VITE_API_URL', import.meta.env.VITE_API_URL, ''),
  CLERK_PUBLISHABLE_KEY: getEnv('VITE_CLERK_PUBLISHABLE_KEY', import.meta.env.VITE_CLERK_PUBLISHABLE_KEY, ''),
  LOCIZE_PROJECT_ID: getEnv('VITE_LOCIZE_PROJECT_ID', import.meta.env.VITE_LOCIZE_PROJECT_ID, ''),
  LOCIZE_API_KEY: getEnv('VITE_LOCIZE_API_KEY', import.meta.env.VITE_LOCIZE_API_KEY, ''),
  MUI_LICENSE_KEY: getEnv('VITE_MUI_LICENSE_KEY', import.meta.env.VITE_MUI_LICENSE_KEY, ''),
};

export { env };
